import { resolveDirective as _resolveDirective, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, renderSlot as _renderSlot } from "vue";
const _hoisted_1 = {
  class: "product-item-main"
};
const _hoisted_2 = {
  class: "product-item-img-box cursor-pointer"
};
const _hoisted_3 = ["alt"];
const _hoisted_4 = ["alt"];
const _hoisted_5 = {
  key: 3,
  class: "variants-popup custom-scrollbar"
};
const _hoisted_6 = {
  class: "variants-popup-content text-center"
};
const _hoisted_7 = {
  class: "form-label"
};
const _hoisted_8 = {
  class: "label-value-2"
};
const _hoisted_9 = {
  class: "swatch-element"
};
const _hoisted_10 = ["onClick"];
const _hoisted_11 = {
  class: "button button2 add-to-cart-btn is-visible",
  type: "submit"
};
const _hoisted_12 = {
  key: 4,
  class: "card-product__group group-right hidden lg:flex"
};
const _hoisted_13 = {
  class: "card-product__group-item card-quickview card-quickviewIcon"
};
const _hoisted_14 = {
  class: "text"
};
const _hoisted_15 = {
  key: 5,
  class: "card__badge badge-left"
};
const _hoisted_16 = {
  class: "product-item-detail relative"
};
const _hoisted_17 = ["title"];
const _hoisted_18 = {
  key: 1,
  class: "hidden product-item-description"
};
const _hoisted_19 = {
  key: 0,
  class: "del"
};
const _hoisted_20 = {
  key: 2,
  class: "product-item-activity text-center"
};
const _hoisted_21 = {
  key: 4,
  class: "product-item-detail__popup relative"
};
const _hoisted_22 = {
  class: "variants-popup custom-scrollbar"
};
const _hoisted_23 = {
  class: "variants-popup-content text-center"
};
const _hoisted_24 = {
  class: "selector-wrapper selector-wrapper-2 swatch"
};
const _hoisted_25 = {
  class: "form-label"
};
const _hoisted_26 = {
  class: "label-value-2"
};
const _hoisted_27 = {
  class: "swatch-element"
};
const _hoisted_28 = ["onClick"];
const _hoisted_29 = {
  class: "button button2 add-to-cart-btn is-visible",
  type: "submit"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_g_button = _resolveComponent("g-button");
  const _directive_jump_to = _resolveDirective("jump-to");
  const _directive_lazy = _resolveDirective("lazy");
  return _openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["product-item-container", {
      'product-item-main__one': _ctx.oneLine
    }])
  }, [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_ctx.activeProd.imageUrl ? _withDirectives((_openBlock(), _createElementBlock("img", {
    key: 0,
    onClick: _cache[0] || (_cache[0] = ev => _ctx.lazyData(ev, _ctx.activeProd)),
    class: "product-item-img",
    alt: _ctx.activeProd.productsName
  }, null, 8, _hoisted_3)), [[_directive_jump_to, _ctx.productUrlWithSku], [_directive_lazy, _ctx.activeProd.imageUrl]]) : _createCommentVNode("", true), _ctx.activeProd.imageUrlNext ? _withDirectives((_openBlock(), _createElementBlock("div", {
    key: 1,
    class: "product-item-img-hover",
    onClick: _cache[1] || (_cache[1] = ev => _ctx.lazyData(ev, _ctx.activeProd))
  }, [_withDirectives(_createElementVNode("img", {
    class: "product-item-img",
    alt: _ctx.activeProd.productsName
  }, null, 8, _hoisted_4), [[_directive_lazy, _ctx.activeProd.imageUrlNext]])])), [[_directive_jump_to, _ctx.productUrlWithSku]]) : _createCommentVNode("", true), !_ctx.variantsPopup ? (_openBlock(), _createBlock(_component_g_button, {
    key: 2,
    class: "button-ATC hidden lg:block",
    type: "primary",
    size: "small",
    onClick: _ctx.showVariantsPop,
    "is-rainbow": false,
    loading: _ctx.fastLoading
  }, {
    default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t("message.home.product_detail.add_to_cart")), 1)]),
    _: 1
  }, 8, ["onClick", "loading"])) : !_ctx.oneLine ? (_openBlock(), _createElementBlock("div", _hoisted_5, [_createElementVNode("a", {
    href: "javascript:;",
    onClick: _cache[2] || (_cache[2] = $event => _ctx.variantsPopup = false),
    class: "variants-popup-close iconfont-g icon-close"
  }), _createElementVNode("div", _hoisted_6, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.variantsData.value, (variantsDataItem, key) => {
    return _openBlock(), _createElementBlock("div", {
      class: "selector-wrapper selector-wrapper-2 swatch",
      key: key
    }, [_createElementVNode("label", _hoisted_7, [_createTextVNode(_toDisplayString(key) + ": ", 1), _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.relaProdSize[key] || '-'), 1)]), _createElementVNode("div", _hoisted_9, [_createElementVNode("ul", null, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(variantsDataItem.list, (item, index) => {
      return _openBlock(), _createElementBlock("li", {
        class: _normalizeClass([{
          active: _ctx.relaProdSize[key] == item
        }, !variantsDataItem.canBuy[index] ? 'soldout' : '']),
        key: index,
        onClick: $event => _ctx.changeSize(item, variantsDataItem, key, variantsDataItem.canBuy[index])
      }, _toDisplayString(item), 11, _hoisted_10);
    }), 128))])])]);
  }), 128)), _createElementVNode("div", {
    class: _normalizeClass(["product-card__button2", [{
      'sold-out': !_ctx.relaProdSize
    }, _ctx.fastLoading ? 'is-loading' : '']]),
    onClick: _cache[3] || (_cache[3] = $event => _ctx.variantsAddToCart())
  }, [_createElementVNode("button", _hoisted_11, _toDisplayString(!_ctx.relaProdSize ? 'Sold Out' : _ctx.$t("message.home.product_detail.submit")), 1)], 2)])])) : _createCommentVNode("", true), _ctx.showQuickView ? (_openBlock(), _createElementBlock("div", _hoisted_12, [_createElementVNode("div", _hoisted_13, [_createElementVNode("a", {
    class: "quickview-icon",
    onClick: _cache[4] || (_cache[4] = (...args) => _ctx.showFastPop && _ctx.showFastPop(...args)),
    href: "javascript:void(0)"
  }, [_createElementVNode("span", _hoisted_14, _toDisplayString(_ctx.$t("message.home.product_detail.quick_view")), 1), _cache[9] || (_cache[9] = _createElementVNode("i", {
    class: "iconfont-g icon-moren"
  }, null, -1))])])])) : _createCommentVNode("", true), _ctx.activeProd.actTags && _ctx.activeProd.actTags.length ? (_openBlock(), _createElementBlock("div", _hoisted_15, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.activeProd.actTags, tag => {
    return _openBlock(), _createElementBlock("span", {
      class: _normalizeClass(`badge badge-${tag.type}`),
      key: tag.type
    }, _toDisplayString(tag.name), 3);
  }), 128))])) : _createCommentVNode("", true)]), !_ctx.oneLine ? (_openBlock(), _createBlock(_component_g_button, {
    key: 0,
    style: _normalizeStyle({
      opacity: _ctx.variantsPopup ? 0 : 1
    }),
    class: "button-ATC lg:hidden",
    type: "primary",
    size: "small",
    onClick: _ctx.showVariantsPop,
    "is-rainbow": false,
    loading: _ctx.fastLoading
  }, {
    default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t("message.home.product_detail.add_to_cart")), 1)]),
    _: 1
  }, 8, ["style", "onClick", "loading"])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_16, [_ctx.showTitle ? _withDirectives((_openBlock(), _createElementBlock("p", {
    key: 0,
    class: "product-item-name cursor-pointer",
    onClick: _cache[5] || (_cache[5] = ev => _ctx.lazyData(ev, _ctx.activeProd)),
    title: _ctx.activeProd.productsName
  }, [_createTextVNode(_toDisplayString(_ctx.activeProd.productsName), 1)], 8, _hoisted_17)), [[_directive_jump_to, _ctx.productUrlWithSku]]) : _createCommentVNode("", true), _ctx.activeProd.productDescriptionValue ? (_openBlock(), _createElementBlock("p", _hoisted_18, _toDisplayString(_ctx.activeProd.productDescriptionValue), 1)) : _createCommentVNode("", true), _withDirectives((_openBlock(), _createElementBlock("p", {
    class: _normalizeClass(["product-item-price", {
      discount: _ctx.activeProd.discount
    }]),
    onClick: _cache[6] || (_cache[6] = ev => _ctx.lazyData(ev, _ctx.activeProd))
  }, [_ctx.activeProd.discount ? (_openBlock(), _createElementBlock("del", _hoisted_19, _toDisplayString(_ctx.activeProd.formatProductsPrice), 1)) : _createCommentVNode("", true), _createTextVNode(" " + _toDisplayString(_ctx.activeProd.formatFinalPrice), 1)], 2)), [[_directive_jump_to, _ctx.productUrlWithSku]]), _ctx.activeProd.configActText ? (_openBlock(), _createElementBlock("div", _hoisted_20, _toDisplayString(_ctx.activeProd.configActText), 1)) : _createCommentVNode("", true), _ctx.oneLine ? (_openBlock(), _createBlock(_component_g_button, {
    key: 3,
    class: "button-ATC",
    type: "primary",
    size: "small",
    "is-rainbow": false,
    onClick: _ctx.showVariantsPop,
    loading: _ctx.fastLoading
  }, {
    default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t("message.home.product_detail.add_to_cart")), 1)]),
    _: 1
  }, 8, ["onClick", "loading"])) : _createCommentVNode("", true), _ctx.oneLine && _ctx.variantsPopup ? (_openBlock(), _createElementBlock("div", _hoisted_21, [_createElementVNode("div", _hoisted_22, [_createElementVNode("a", {
    href: "javascript:;",
    onClick: _cache[7] || (_cache[7] = $event => _ctx.variantsPopup = false),
    class: "variants-popup-close iconfont-g icon-close"
  }), _createElementVNode("div", _hoisted_23, [_createElementVNode("div", _hoisted_24, [_createElementVNode("label", _hoisted_25, [_createTextVNode(_toDisplayString(_ctx.$t("message.home.product_detail.size")) + ": ", 1), _createElementVNode("span", _hoisted_26, _toDisplayString(_ctx.relaProdSize), 1)]), _createElementVNode("div", _hoisted_27, [_createElementVNode("ul", null, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.variantsData, (item, index) => {
    return _openBlock(), _createElementBlock("li", {
      class: _normalizeClass([{
        active: _ctx.relaProdSizeSku == item.sku
      }, !item.canBuy ? 'soldout' : '']),
      onClick: $event => _ctx.changeSize(item),
      key: index
    }, _toDisplayString(item.name), 11, _hoisted_28);
  }), 128))])])]), _createElementVNode("div", {
    class: _normalizeClass(["product-card__button2", [{
      'sold-out': !_ctx.relaProdSize
    }, _ctx.fastLoading ? 'is-loading' : '']]),
    onClick: _cache[8] || (_cache[8] = $event => _ctx.variantsAddToCart())
  }, [_createElementVNode("button", _hoisted_29, _toDisplayString(!_ctx.relaProdSize ? 'Sold Out' : _ctx.$t("message.home.product_detail.submit")), 1)], 2)])])])) : _createCommentVNode("", true)])]), _renderSlot(_ctx.$slots, "option", {
    option: _ctx.activeProd
  })], 2);
}